import { render, staticRenderFns } from "./ScrubSlides.vue?vue&type=template&id=0b609740&scoped=true"
import script from "./ScrubSlides.vue?vue&type=script&lang=js"
export * from "./ScrubSlides.vue?vue&type=script&lang=js"
import style0 from "./ScrubSlides.vue?vue&type=style&index=0&id=0b609740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b609740",
  null
  
)

export default component.exports